import React, { useEffect, useState, useRef } from 'react';
import ApplicationLayout from "../../../layouts/ApplicationLayout";
import { useSelector } from "react-redux";
import { Collapse, Modal } from 'bootstrap';
import Ax from "../../../components/hoc/Ax";
import moment from "moment";
import tapIcon from "../../../services/TapIcon";
import HttpAPICall from "../../../services/HttpAPICall";
import Loader from "../../../components/ui/Loader/Loader";
import {DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom} from "../../../components/TapUi/index";
import {Link} from "react-router-dom";
import DownloadFile from "../../../services/DownloadFile";
import InputItemSearch from '../../includes/ui/InputItemSearch';
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import TapSelect from "../../../components/ui/TapSelect";
import Helmet from 'react-helmet';
import InputVendorSearch from '../../includes/ui/InputVendorSearch';
import PurchaseOrderDetailModal from '../../inventory/purchaseOrder/PurchaseOrderDetailModal';
import ReceivedQtyDetail from '../../inventory/includes/ReceivedQtyDetail';
import swal from "sweetalert";
import InputEmployeeSearch from '../../includes/ui/InputEmployeeSearch';
import { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import uuid from "react-uuid";
import TapHelper from '../../../services/TapHelper';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import POQtyDetail from '../../inventory/includes/POQtyDetail';
import DateService from '../../../services/DateService';
import ReportSchedulerModal from '../includes/ReportSchedulerModal';

function ItemWisePoPurchaseAnalysisReport(props) {
    
    const filterFormID      =   uuid()
    const reportKey         =   'item_wise_lead_time_with_purchase';

    const reportUrl         =   INVENTORY_API_BASE_URL_2 + '/report/item-wise-po-lead-time';

    const access_token      =   useSelector(state => state.auth.access_token);
    const allPeriods        =   useSelector(state => state.app.all_periods ? state.app.all_periods : []);
    const userSites         =   useSelector(state => state.app.user_sites ? state.app.user_sites   : []);
    const allWarehouses     =   useSelector(state => state.app.warehouses ? state.app.warehouses   : []);
    const permissions       =   useSelector(state => state.app.permissions ? state.app.permissions : []);
    const reportListing     =   useSelector(state => state.app.report_listing ? state.app.report_listing : []);
    const itemTags          =   useSelector(state => state.app.item_tags ? state.app.item_tags : []);

    const location          =  useLocation();
    const queryParams       =   new URLSearchParams(location.search);    
    const reportSchedulerModalRef   =   useRef();

    let initFilterFormData  =   {
        show                    :   true,
        per_page                :   50,
        form_data_loaded        :   false,
        loading                 :   false,
        isQueryData             :   false,
        isSearchElement         :   false,
        
        tagged_user_filter      :   '',
        search_po_transaction_id   :   '',
        search_warehouse_ids    :   [],
        search_item_ids         :   [],
        search_item_tags        :   [],
        search_status_ids       :   [],
        search_priority         :   '',
        search_manufacturer_ids :   [],
        search_vendor_ids       :   [],
        date_range              :   '',
        date_range_start        :   '',
        date_range_end          :   '',
        search_workstation_ids  :   [],
        search_asset_ids        :   [],
        search_employee_ids     :   [],
        tagged_user_ids         :   [],
        search_po_type          :   "",
        aging_type              :   "",
        aging_type_value        :   ""
    }

    let formDataLabel       =   {
        tagged_user_filter      :   'User Tagging : ',
        search_po_transaction_id   :   'PO Number : ',
        search_warehouse_ids    :   'Warehouse : ',
        search_workstation_ids  :   'WorkStation : ',
        search_asset_ids        :   'Asset : ',
        search_item_ids         :   'Items : ',
        search_item_tags        :   'Item Tags : ',
        search_status_ids       :   'Status : ',
        search_vendor_ids       :   'Vendor : ',
        search_priority         :   'Search Priority : ',
        search_manufacturer_ids :   'Manufacturer : ',
        date_range              :   'Date Range : ',
        search_employee_ids     :   'Employees : ',
        tagged_user_ids         :   'Tagged Users : ',
        aging_type              :   'Aging Type : ',
        aging_type_value        :   'Due Aging : '
    };

    const types             =   [
        {label : "Asset", value: "asset"},
        {label : "Workstation", value: "workstation"},
        {label : "Employee", value: "employee"},
    ];
    const agingTypes        =   [
        {label : "Overdue Aging", value: "overdue_aging"},
        {label : "Due soon Aging", value: "due_soon_aging"},
    ]

    const [filterFormData, setFilterFormData]       =   useState(initFilterFormData)
    const [searchedElems, setSearchedElems]     =   useState([]);
    const [formData, setFormData]       =   useState({
        allWarehouses       :   [],
        allItemTags         :   [],
        allPeriods          :   [],
        searchedVendor      :   [],
        allStatusOptions    :   [],
        allPriorityOptions  :   [],
        manufactures        :   [],
        allUsers            :   [],

        searchedItem        :   [],
        searchedAssets      :   [],
        searchedEmployees   :   [],
    })
    const [onScreenData, setOnScreenData]       =   useState({ 
        loading             :   false,
        show                :   false,
        reportDownloadBtn   :   false,
        reportDownloading   :   false,
        data                :   [],
        meta                :   null,
        page                :   1
    });
    const [scheduleFilteredData, setScheduleFilteredData] = useState({});

    const criteriaRef   =   useRef()
    const pODetailModalRef   =   useRef()
    const [criteriaHeight ,setCriteriaHeight ] =    useState(0)

    const updateCriteriaHeight = () => {
        if (criteriaRef.current) {
            const height = criteriaRef.current.offsetHeight;
            if (criteriaHeight !== height) {
                setCriteriaHeight(height)
            }
        }
    };
    useEffect(() => {
        updateCriteriaHeight()
        toggleFilterForm(filterFormData.show);
        if (filterFormData.show && !filterFormData.form_data_loaded) {
            loadFormData();
        }
    }, [filterFormData.show]);
    useEffect(()=> {
        
        if(filterFormData.isQueryData && (queryParams.get('due_soon_aging') || queryParams.get('overdue_aging') || queryParams.get('search_status_ids') || queryParams.get('search_warehouse_id') || queryParams.get('tagged_user_filter'))) {
            reportFilterFormSubmit()
            setFilterFormData(pre => ({...pre, isQueryData : false}))
        }
    }, [filterFormData.isQueryData])

      useEffect(() => {
        if(filterFormData.isSearchElement) {
            loadListData()
        }
    }, [filterFormData.isSearchElement])

    const loadFormData      =   ()  =>  {
        setFilterFormData(pre => ({ ...pre, loading: true }));
        HttpAPICall.withAthorization('GET', reportUrl, access_token, {action:"formData"}, null, (resp) => {
            const {manufacturers, priorities, purchase_order_type, status, users, workstations} =  resp.data;
            setFilterFormData(pre => ({...pre, form_data_loaded : true}))
            setFormData(pre => ({
                ...pre,
                allPeriods          :   [...allPeriods , {key : 'custom' , display : 'Custom Date Range'}],
                manufactures        :   manufacturers.length > 0  
                    ? manufacturers.map((m) => { return {value: m.id, label: m.name}}) : [],

                allStatusOptions    :   status.length > 0 
                    ? status.map((s) => { return {value: s.id, label: s.name,level : s.level}; }) : [],

                allPriorityOptions  :   priorities.length > 0 
                    ? priorities.map((s) => { return {value: s.key, label: s.name}; }) : [],
                
                allItemTags         :   itemTags.length > 0 
                    ? itemTags.map((s) => { return {value: s.id, label: s.name}; }) : [],

                workstations        :   workstations.length > 0 
                    ?  workstations.map((w) => {return {value: w.id, label: `${w.workstation_name} (${w.workstation_nickname})`}}) : [],

                allUsers            :   users 
                    ? users.map((s) => { return {value: s.id, label: s.full_name,site_ids:s.linked_sites}; }) : [],

                allWarehouses       :   allWarehouses.map((m) => { return { value: m.id, label: `${m.name} (${m.code})` }}),


            }))          
        }).then(() => {
            setFilterFormData(pre => ({ ...pre, loading: false }))
            let search_status_ids   =   queryParams.get('search_status_ids') ? JSON.parse(queryParams.get('search_status_ids')) : filterFormData.search_status_ids;
            let {aging_type, aging_type_value, isQueryData, search_warehouse_ids, tagged_user_filter}  
                                    =   filterFormData; 
            if(queryParams.get('due_soon_aging')) {
                aging_type          =   "due_soon_aging";
                aging_type_value    =   queryParams.get('due_soon_aging');
                isQueryData         =   true
            }
            if(queryParams.get('overdue_aging')) {
                aging_type          =   "overdue_aging";
                aging_type_value    =   queryParams.get('overdue_aging');
                isQueryData         =   true
            }
            if(queryParams.get('search_warehouse_id')) {
                search_warehouse_ids=   [Number(queryParams.get('search_warehouse_id'))];
                isQueryData         =   true
            }
            if(queryParams.get('tagged_user_filter')) {
                tagged_user_filter  =   queryParams.get('tagged_user_filter');
                isQueryData         =   true
            }
            setFilterFormData(pre => ({...pre, aging_type, aging_type_value, isQueryData, search_status_ids, search_warehouse_ids, tagged_user_filter}))
        });
    }

    const loadListData      =   (page = 1)  =>  {
        
        setOnScreenData(pre => ({...pre, loading : true}));
        setFilterFormData(pre => ({...pre, isSearchElement : false}));
        let params = {
            action: 'po_purchase_data',
            page,
            ...TapHelper.pick(filterFormData, ["tagged_user_filter", "search_po_transaction_id", "search_warehouse_ids", "search_item_ids", "search_item_tags", "search_status_ids", "search_priority", "search_manufacturer_ids", "search_vendor_ids", "date_range", "date_range_start", "date_range_end", "search_workstation_ids", "search_asset_ids", "search_employee_ids", "tagged_user_ids", "search_po_type", "aging_type", "aging_type_value"])
        };      
       setScheduleFilteredData(pre => ({...pre, date_range_start : filterFormData.date_range_start, date_range_end: filterFormData.date_range_end}));
       

        HttpAPICall.withAthorization('GET', reportUrl, access_token, params, null, (resp) => {
            const respData  =  resp.data;
            let meta        =  TapHelper.pick(respData, ['from', 'to', 'total', 'last_page', 'per_page', 'current_page']);
            setOnScreenData(pre => ({
                ...pre,   
                reportDownloadBtn: true,
                data : respData.data,
                meta
            }))
        }).then(() => setOnScreenData(pre => ({...pre, loading : false})));    
          
    }

    const validateString  =   (str)   =>  {
        // Check if string matches any of the allowed patterns
        return /^(\d+\-\d+|\d+\+|\d+)$/.test(str);
    }

    const closeReport       =   ()  =>  props.history.push({ pathname: `/report` })

    const toggleFilterForm      =  (show)   =>  {
        setFilterFormData(pd => ({ ...pd, show: show }))
        if (document.getElementById('pageTbl')) {
            document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
        }
    }
    const handleChangeOption    =   (selectedOption, optionName)  => {
        
        let data    =   (Array.isArray(selectedOption)) 
            ? selectedOption.map(op => op.value) 
            : selectedOption 
                ? selectedOption.value
                : ""
        
        setFilterFormData(pre => ({...pre, [optionName] : data}))
    }

    const inputFieldHandler =   (e) => {
        setFilterFormData(pre => ({...pre, [e.target.name] : e.target.value}))
    }

    const reportFilterFormSubmit = (e) => {
        e && e.preventDefault()
 
        let runApi              =   true;
        if(filterFormData.aging_type == 'overdue_aging' && filterFormData.aging_type_value && !validateString(filterFormData.aging_type_value)) {
            runApi              =   false;
            toast.error("Invalid Overdue aging, Please enter Like: 0-5 for a range or 5 for Overdue Aging or 5+", {position: toast.POSITION.TOP_RIGHT});
        }
        if(filterFormData.aging_type == 'due_soon_aging' && filterFormData.aging_type_value && !validateString(filterFormData.aging_type_value)) {
            runApi              =   false;
            toast.error("Invalid Due soon aging, Please enter Like: 1-5 for a range or 5 for Overdue Aging or 5+", {position: toast.POSITION.TOP_RIGHT});
        }

        if(runApi) {
            toggleFilterForm(false);
            let serachFormKeys          =   Object.keys(filterFormData);
            let searchedElems           =   [];
            let itemSearchParams        =   {};
             let hasFilters             =   false; 
             let newScheduleFilteredData = {};
            serachFormKeys.map((key)        =>  {
                let label               =   formDataLabel[key];
                let value               =   filterFormData[key];
                if(value && value.toString().length > 0) {
                     hasFilters = true; 
                    itemSearchParams[key]      =   value;
                    if(label) {
                        // setScheduleFilteredData(pre => ({...pre, [key] : value}));
                         newScheduleFilteredData[key] = value;
                        let show_val            =   value;
                        if(key == 'tagged_user_filter') {
                            // show_val            =   this.state.userFilters.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                        }
                        if(key == 'search_warehouse_ids') {
                            show_val            =   formData.allWarehouses.filter((s) => filterFormData.search_warehouse_ids.includes(s.value)).map(s => s.label);
                        }
                        if(key == 'search_item_ids') {
                            show_val            =   formData.searchedItem ? formData.searchedItem.map(s => s.display_label).join(', ') : '';
                        }
                        if(key == 'search_item_tags') {
                            show_val            =   formData.allItemTags.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                        }
                        if(key == 'search_vendor_ids') {
                            show_val            =   formData.searchedVendor ? formData.searchedVendor.map(s => s.vendor?.name).join(', ') : '';
                        }
                        if(key == 'search_po_transaction_id') {
                            show_val            =   filterFormData ? filterFormData.search_po_transaction_id : '';
                        }
                        if(key == 'aging_type') {
                            show_val            =   agingTypes.find(v => v.value ==  filterFormData.aging_type)?.label;
                        }
                        if(key == 'aging_type_value') {
                            show_val            =   filterFormData ? filterFormData.aging_type_value : '';
                        }
                        if(key == 'search_status_ids') {
                            show_val            =   formData.allStatusOptions.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                        }
                        if(key == 'search_priority') {
                            show_val            =   formData.allPriorityOptions.filter((s) => value.includes(s.value)).map(s => s.label);
                        }
                        if(key == 'search_manufacturer_ids') {
                            show_val            = formData.manufactures.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                        }
                        if(key == 'search_workstation_ids') {
                            show_val            =   formData.workstations.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                        }
                        if(key == 'search_asset_ids') {
                            show_val            =   formData.searchedAssets ? formData.searchedAssets.map(s => s.display_label).join(', ') : '';
                        }
                        if(key == 'search_employee_ids') {
                            show_val            =   formData.searchedEmployees ? formData.searchedEmployees.map(s => s.label).join(', ') : '';
                        }
                        if(key == 'tagged_user_ids') {
                            show_val            =   formData.allUsers.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                        }
    
                        if(key == 'date_range') {
                            let start_range         =      moment(filterFormData.date_range_start).format('DD-MMM-YYYY');
                            let end_range           =      moment(filterFormData.date_range_end).format('DD-MMM-YYYY')
                            let display_custom      =      `Custom Date Range (${start_range} - ${end_range})`
                            show_val                =     formData.allPeriods.filter((s) => value.includes(s.key)).map(s => s.display_with_date ? s.display_with_date : display_custom);

                            // setScheduleFilteredData(pre => ({...pre, [key] : value}));
                              newScheduleFilteredData[key] = value;
                        }
                        searchedElems.push(label + `<b>${show_val}</b>`);
                    }
                }
            })
            if (!hasFilters) {
                setScheduleFilteredData({});
            } else {
                setScheduleFilteredData(newScheduleFilteredData);
            }
            setFilterFormData(pre => ({...pre, isSearchElement : true}))
            setSearchedElems(searchedElems);
            setOnScreenData(pre => ({...pre, show : true}))
        }

    }

    const poQtyDetailModalInit  =   (item_id)  =>  {
        pODetailModalRef.current.modalPOInit(item_id);
    }

    const downloadReport    =   ()  => {
        let params = {
            action: 'download_with_purchase',
            ...TapHelper.pick(filterFormData, ["tagged_user_filter", "search_po_transaction_id", "search_warehouse_ids", "search_item_ids", "search_item_tags", "search_status_ids", "search_priority", "search_manufacturer_ids", "search_vendor_ids", "date_range", "date_range_start", "date_range_end", "search_workstation_ids", "search_asset_ids", "search_employee_ids", "tagged_user_ids", "search_po_type", "aging_type", "aging_type_value"])
        };


        if(params.overdue_aging != '' || params.due_soon_aging != '') {
            reportDownloadApiCall(params);
        } else if(params.date_range == '') {
            swal({ 
                title: "Download", icon: "warning", buttons: ["Cancel", "Okay"],
                text: "The download will be for Current Quarter, in case you want a different Period then apply the criteria before downloading.",
            }).then(willDownload => {
                if (willDownload) { reportDownloadApiCall({...params, date_range: "current_quarter"}); }
            });
        }
        
    }

    const reportDownloadApiCall     =   (formData)  =>  {
        setOnScreenData(pre => ({
            ...pre,
            reportDownloading : true
        }));

        HttpAPICall.withAthorization('GET', reportUrl, access_token, formData , {} , (response) => DownloadFile.file(null,response.data.msg, response.data.navigation,props))
        .then(() => {
            setOnScreenData(pre => ({
                ...pre,
                reportDownloading : false
            }))
        });
    }

    const reportScheduleHandler         =   () => {
        if (reportSchedulerModalRef.current) {
            reportSchedulerModalRef.current.initModalHandler(reportKey);
        }
    }

    const reportFilterFormJsx = () => {
        return (
            <form onSubmit={reportFilterFormSubmit} className={['p-3', 'filter_form'].join(' ')}>
                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Item</label>
                    <div className="col-sm-6">
                        <InputItemSearch
                            placeholder="Search Item"
                            isMulti={true}
                            changeEvent={(selectedOption) => {
                                handleChangeOption(selectedOption, 'search_item_ids');
                                setFormData(pre => ({...pre, searchedItem : selectedOption}))
                            }}
                            value={formData.searchedItem.length > 0 ? formData.searchedItem.map(a => { a.label = a.display_label; return a; }) : []}
                        />
                    </div>
                </div>
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Item Tags</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={formData.allItemTags}
                            changeEvent={(selectedOption) => handleChangeOption(selectedOption,'search_item_tags')}
                            value={formData.allItemTags.filter(u => filterFormData.search_item_tags.includes(u.value))}
                            isSearchable={true}
                            isMulti={true}
                            isClearable={true}
                            placeholder="Select Item Tags"
                        />
                    </div>
                </div>
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Tagged User</label>
                    <div className="col-sm-6">
                        <TapSelect
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            placeholder="Tagged User"
                            options={formData.allUsers}
                            value={formData.allUsers.filter(s => filterFormData.tagged_user_ids.includes(s.value))}
                            changeEvent={(selectedOption) => handleChangeOption(selectedOption, 'tagged_user_ids')}
                        />
                    </div>
                </div>

                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Manufacturer</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={formData.manufactures}
                            changeEvent={(selectedOption) => handleChangeOption(selectedOption, 'search_manufacturer_ids')}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={formData.manufactures.filter(s => filterFormData.search_manufacturer_ids.includes(s.value))}
                            placeholder="Select Manufacturer"
                        />
                    </div>
                </div>
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Warehouse</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={formData.allWarehouses}
                            changeEvent={(selectedOption) => handleChangeOption(selectedOption, 'search_warehouse_ids')}
                            value={formData.allWarehouses.filter(u => filterFormData.search_warehouse_ids.includes(u.value))}
                            isSearchable={true}
                            isMulti={true}
                            isClearable={true}
                            placeholder="Select Warehouses"
                        />
                    </div>
                </div>
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Vendor</label>
                    <div className="col-sm-6">
                        <InputVendorSearch
                            changeEvent={(selectedOption) => {
                                handleChangeOption(selectedOption, 'search_vendor_ids');
                                setFormData(pre => ({...pre, searchedVendor : selectedOption}))
                            }}
                            isMulti={true}
                            value={formData.searchedVendor.length > 0 ? formData.searchedVendor.map(a => { a.label = a.display_label; return a; }) : []}
                        />
                    </div>
                </div>
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">PO Number</label>
                    <div className="col-sm-6">
                        <input
                            name="search_po_transaction_id"
                            type="text"
                            value={filterFormData.search_po_transaction_id}
                            className="form-control"
                            autoComplete="off"
                            onChange={(e) => inputFieldHandler(e)}
                            placeholder="Please Enter Transaction ID"
                        />
                    </div>
                </div>

                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">PO For</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={types}
                            changeEvent={(selectedOption) => handleChangeOption(selectedOption, 'search_po_type')}
                            value={types.find(u => u.value == filterFormData.search_po_type)}
                            isSearchable={true}
                            isClearable={true}
                            placeholder="Select PO For"
                        />
                    </div>
                </div>
                {
                    filterFormData.search_po_type === "asset" &&
                    <div className="row my-3 align-items-center">
                        <label className="col-sm-3 col-form-label text-end">Asset</label>
                        <div className="col-sm-6">
                            <InputAssetSearch
                                changeEvent={(selectedOption) => {
                                    handleChangeOption(selectedOption, 'search_asset_ids');
                                    setFormData(pre => ({...pre, searchedAssets : selectedOption, searchedEmployees : []}))
                                    setFilterFormData(pre => ({...pre, search_workstation_ids : [], search_employee_ids : []}))
                                }}
                                isMulti={true}
                                value={formData.searchedAssets.length > 0 ? formData.searchedAssets.map(a => { a.label = a.display_label; return a; }) : []}
                            />
                        </div>
                    </div>
                }
                {
                    filterFormData.search_po_type === "workstation" &&
                    <div className="row my-3 align-items-center">
                        <label className="col-sm-3 col-form-label text-end">Workstation</label>
                        <div className="col-sm-6">
                            <TapSelect
                                changeEvent={(selectedOption) => {
                                    handleChangeOption(selectedOption, 'search_workstation_ids')
                                    setFilterFormData(pre => ({...pre, search_asset_ids : [], search_employee_ids : []}))
                                    setFormData(pre => ({...pre, searchedAssets : [], searchedEmployees : []}))
                                }}
                                options={formData.workstations}
                                isSearchable={true}
                                isClearable={true}
                                value={formData.workstations.filter(t => filterFormData.search_workstation_ids.includes(t.value))}
                                placeholder="Please Select Workstation"
                                isMulti={true}
                            />
                        </div>
                    </div>
                }
                {
                    filterFormData.search_po_type === "employee" &&
                    <div className="row my-3 align-items-center">
                        <label className="col-sm-3 col-form-label text-end">Employee</label>
                        <div className="col-sm-6">
                            <InputEmployeeSearch
                                changeEvent={(selectedOption) => {
                                    handleChangeOption(selectedOption, 'search_employee_ids');
                                    setFormData(pre => ({...pre, searchedEmployees : selectedOption, searchedAssets : []}));
                                    setFilterFormData(pre => ({...pre, search_asset_ids : [], search_workstation_ids : []}))
                                }}
                                isMulti={true}
                                value={formData.searchedEmployees.length > 0 ? formData.searchedEmployees.map(a => { a.label = a.label; return a; }) : []}
                            />
                        </div>
                    </div>
                }


                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Priority</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={formData.allPriorityOptions}
                            changeEvent={(selectedOption) => handleChangeOption(selectedOption, 'search_priority')}
                            value={formData.allPriorityOptions.find(u => u.value == filterFormData.search_priority)}
                            isSearchable={true}
                            isClearable={true}
                            placeholder="Select Priority"
                        />
                    </div>
                </div>
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Status</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={formData.allStatusOptions}
                            changeEvent={(selectedOption) => handleChangeOption(selectedOption, 'search_status_ids')}
                            isMulti={true}
                            isClearable={true}
                            value={formData.allStatusOptions.filter(s => filterFormData.search_status_ids.includes(s.value))}
                            placeholder="Select Status"
                        />
                    </div>
                </div>

                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Aging Type</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={agingTypes}
                            changeEvent={(so) => {
                                setFilterFormData(pre => ({...pre, aging_type : so ? so.value : null , aging_type_value: so ? filterFormData.aging_type_value : ''}))
                            }}
                            value={agingTypes.find(u => u.value == filterFormData.aging_type)}
                            isSearchable={true}
                            isClearable={true}
                            placeholder="Select Aging Type"
                        />
                    </div>
                </div>
                {
                    filterFormData.aging_type &&
                    <div className="row my-3 align-items-center">
                        <label className="col-sm-3 col-form-label text-end require">{agingTypes.find(u => u.value == filterFormData.aging_type).label}</label>
                        <div className="col-sm-6">
                            <input
                                required={true}
                                type="text"
                                value={filterFormData.aging_type_value}
                                className="form-control"
                                autoComplete="off"
                                onChange={e => setFilterFormData(pre => ({...pre, aging_type_value: e.target.value})) }
                                placeholder="Example. 0-5 for a range or 4 for Overdue Aging or 10+"
                            />
                        </div>
                    </div>
                }

                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">PO Transaction Period</label>
                    <div className="col-sm-6">
                        <PeriodSelectionWithCustom
                            periods={formData.allPeriods}
                            value={filterFormData.date_range}
                            startDate={filterFormData.date_range_start}
                            endDate={filterFormData.date_range_end}
                            onSelectPeriod={(period, startDate, endDate) => {
                                setFilterFormData((pre) => ({
                                    ...pre,
                                    date_range: period,
                                    date_range_start: startDate ? startDate : null,
                                    date_range_end: endDate ? endDate : null
                                }))
                            }}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="pb-3 col-9 text-end">
                        <button type="submit" disabled={false} className="btn btn-primary px-4">Show Report</button>
                    </div>
                    <hr />
                </div>
            </form>
        );
    }

    const pageTitleBarJsx       =   ()  =>  {
        return (<div className="page_title row m0">
            <div className="col-sm-12">
                {/* {this.state.reportData?.name} */}
                <h3><tapIcon.FontAwesomeIcon icon={tapIcon.faCubes} /> Item Wise PO Purchase Analysis Report</h3>
                <div className="text-end mt15">
                    <button type="button" onClick={() => toggleFilterForm(!filterFormData.show)} className="btn btn-secondary">Change Filter</button>
                    <button type="button" onClick={reportScheduleHandler} className="btn btn-secondary">Schedule Report</button>
                    {
                        onScreenData.reportDownloadBtn && 
                    <> 
                        <button disabled={onScreenData.reportDownloading} type="button" className="btn btn-secondary" onClick={downloadReport}>
                        <tapIcon.FontAwesomeIcon icon={tapIcon.faDownload} />
                        {onScreenData.reportDownloading ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin ms-2" />) : null }
                        </button>
                    </>
                    }
                    <button type="button" className="btn btn-secondary" onClick={closeReport}>
                        <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                    </button>
                </div>
            </div>
        </div>);
    }

    const listData   =   () => {
        return (<>
            <div ref={criteriaRef}
            style={{
                position: 'sticky',
                top: 0,
                background: 'white',
            }}>
                <DisplaySearchCriteria searchedElems={searchedElems} />
            </div>
            <table className="table table-sm table-bordered align-middle bg-white">
                <thead className="align-middle table-secondary" style={{
                    top: `${criteriaHeight}px`,
                    position: 'sticky',
                }}>
                    <tr>
                        <th className='text-center' style={{ width: "8%" }}>PO Number</th>
                        <th className='text-center' style={{ width: "7%" }}>PO Date</th>
                        <th className="text-center" style={{ width: "18%" }}>Item</th>
                        <th className="text-center" style={{ width: "18%" }}>Warehouse</th>
                        <th scope="col" style={{ width: "7%" }}  >PO Qty</th>
                        <th scope="col" style={{ width: "7%" }} >Actual PO Qty</th>
                        <th scope="col" style={{ width: "7%" }} >Status</th>
                        <th scope="col" style={{ width: "7%" }} >Delivery Due Date</th>
                        <th scope="col" style={{ width: "7%" }} >Ageing from Delivery Due Date</th>
                        <th scope="col" style={{ width: "7%" }} >Purchase Qty.</th>
                        <th scope="col" style={{ width: "7%" }}>Date of Item Delivery</th>
                        <th scope="col" style={{ width: "7%" }}>Delivery Time (From PO Release to Item Delivery)</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        onScreenData.loading 
                        ? <tr className='text-center'><td colSpan={11}><Loader/></td></tr>
                        :
                        onScreenData.data.length > 0 
                        ? 
                        onScreenData.data.map((poData) => {
                            return poData.row_items.map((poItem, i) => (
                            <tr key={i}>
                                <td>
                                    <button type="button" className="btn btn-link text-decoration-none" onClick={() => poQtyDetailModalInit(poData.transaction_id)}>{poData.transaction_id}</button>
                                </td>
                                <td>{poData.transaction_date}</td>
                                <td>{poData.item_name} <br/> 
                                    <b>Code : </b>{poData.item_code}
                                </td>
                                <td>{poData.warehouse_name} 
                                    <br/> 
                                    <b>Code : </b>{poData.warehouse_code}
                                </td>
                                <td className='text-end'>{poItem.po_qty}</td>
                                <td className='text-end'>{poData.actual_po_qty}</td>
                                <td className='text-end'>{poItem.item_row_status}</td>
                                <td>{DateService.dateFormat(poData.due_date)}</td>
                                <td className='text-end'>{poData.due_period ? parseInt(poData.due_period) : ''}</td>
                                <td className='text-end'>{poItem?.purchase_qty}</td>
                                <td>{poItem.purchase_purchased_date ? DateService.dateFormat(poItem.purchase_purchased_date) : ''}</td>
                                <td className='text-end'>{poItem?.time_po_release_to_purchase}</td>
                            </tr>
                            ))
                        })
                        : <tr className='text-center'><td colSpan={11}>No Record Found</td></tr>
                    }
                </tbody>
            </table>
            <DisplayListPagination meta={onScreenData.meta} onPageChange={(e) => loadListData(e.selected + 1)} keyName="PO Items"/>
        </>)
    }

    return  <ApplicationLayout>
        <Helmet><title>Item Wise PO Purchase Analysis - Report</title></Helmet>
            {pageTitleBarJsx()}
        <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div id="pageTbl" className="pageTbl col-12 pb-2">
                        <div className={["bg-white", filterFormData.show ? 'tbShow' : 'tbHide'].join(" ")} >
                            {
                                filterFormData.loading ? <Loader/> :  reportFilterFormJsx()
                            }
                        </div>
                        { onScreenData.show &&  listData()
                        }
                    </div>
                </div>
             <PurchaseOrderDetailModal parentProps={props} ref={pODetailModalRef}/>
             <ReportSchedulerModal ref={reportSchedulerModalRef} searchedElems={searchedElems} filteredData={scheduleFilteredData} />
          </div>
    </ApplicationLayout>
}

export default ItemWisePoPurchaseAnalysisReport;